/* eslint-disable */
import React, { useEffect } from "react";
import { getNeighboursMeetings } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const MeetingsCommunities = ({ getNeighboursMeetings, communityMeetings, period, loading }) => {
  useEffect(() => {
    getNeighboursMeetings({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursMeetings(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursMeetings(payload);
  };

  return (
    <DataTable
      preset="meetingsCommunities"
      data={{
        docs: communityMeetings?.docs || [],
        totalPages: communityMeetings?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={loading}
    />
  );
};

const mapStateToProps = (state) => ({
  communityMeetings: state.appCommunities.communityMeetings,
  loading: state.appCommunities.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getNeighboursMeetings: (payload) => dispatch(getNeighboursMeetings(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MeetingsCommunities);